import $ from "../../../node_modules/dabbyjs/src/core/dabby/dabby.js";
import "../../../node_modules/dabbyjs/src/attributes/prop/prop.js";
import storage from "../../swgfl/javascript/storage.js";
import popup from "../../swgfl/javascript/popup.js";

export default obj => {
	if (obj.length && storage()) {
		const key = "rhc-survey",
			value = localStorage.getItem(key),
			now = Date.now();

		// check the last time they saw the popup
		if (value === null || value < now) {

			// start the popup code
			popup($(".footer"), () => {
				obj.prop("checked", true);
				localStorage.setItem(key, now + 604800000); // 7 days
			}, 5000);
		}

		// don't show the survey for one year if they take the survey
		$(".survey__button").on("click", () => {
			localStorage.setItem(key, now + 31536000000);
			obj.prop("checked", false);
		});
	}
};
